import React, { forwardRef } from 'react';

// Return a valid DOM element so Floater can attach refs, but keep it hidden.
const NoBeacon = forwardRef(function NoBeacon({ style, ...props }, ref) {
  return (
    <span
      ref={ref}
      {...props}
      style={{
        display: 'none',
        width: 0,
        height: 0,
        overflow: 'hidden',
        ...style,
      }}
    />
  );
});

export default NoBeacon;
